import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as actions from '../../../../../store/actions';
const ICON_STYLE = {padding: '4px', color: 'rgb(0, 120, 212)', marginRight: '5px'};
const ROW_STYLE = {width: '100%', height: '100%', display: 'flex', alignItems: 'center'};

class Location extends Component {
  render(){
    const isFav = this.props.favorites && this.props.favorites.findIndex(fav => fav.location_id === this.props.location_id) > -1;
    return (<div style={ROW_STYLE}>
      <Icon
        style={ICON_STYLE}
        iconName={ isFav ? 'FavoriteStarFill' : 'FavoriteStar'} 
        onClick={(e) => {
          e.stopPropagation();
          this.props.toggleFavoriteLocation(this.props.river, this.props.location_id, !isFav)
        }}
      />
      {this.props.text}
      </div>)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleFavoriteLocation: (river_id, location_id, favorite) => dispatch(actions.toggleFavoriteLocation(river_id, location_id, favorite))
  }
}

export default connect(null, mapDispatchToProps)(Location);



// WEBPACK FOOTER //
// ./src/components/panel/items/filters/filterComponents/Location.js